/**
 * AlwaysInsured logo system.
 * - <LogoMark />  → the bordered "Ai" monogram (compact icon)
 * - <LogoLockup /> → mark + wordmark (+ optional tagline)
 * - <WordMark />  → the "AlwaysInsured" wordmark
 * - TAGLINE constant is exported so we can reuse everywhere.
 */

export const TAGLINE = "Always there · in all ways possible.";

export const LogoMark = ({ size = 40, className = "" }) => (
  <span
    className={`inline-flex items-center justify-center font-serif relative shrink-0 ${className}`}
    style={{ width: size, height: size, border: "1px solid currentColor" }}
    aria-hidden="true"
  >
    <span
      className="italic tracking-tight leading-none relative"
      style={{ fontSize: size * 0.55 }}
    >
      Ai
    </span>
    <span
      className="absolute left-1/2 -translate-x-1/2 bg-terracotta-500"
      style={{ bottom: size * 0.12, height: 1, width: size * 0.32 }}
    />
  </span>
);

export const WordMark = ({ className = "" }) => (
  <span className={`font-serif tracking-tight leading-none ${className}`}>
    Always<span className="italic text-terracotta-500">Insured</span>
  </span>
);

export const LogoLockup = ({
  tagline = true,
  size = 40,
  wordClass = "text-2xl md:text-[1.75rem]",
  align = "start",
  className = "",
}) => (
  <div className={`inline-flex items-center gap-4 ${className}`}>
    <LogoMark size={size} />
    <div className={`flex flex-col ${align === "center" ? "items-center" : "items-start"} leading-tight`}>
      <WordMark className={wordClass} />
      {tagline && (
        <span className="overline opacity-70 mt-1.5" style={{ letterSpacing: "0.24em" }}>
          {TAGLINE}
        </span>
      )}
    </div>
  </div>
);
